import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { getTotalCountFromHeader, isFunction, isStringTrimNotEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import React, { useEffect } from 'react';
import { useDrillDownReportColumns } from '../hooks/useDrillDownReportColumns';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';

function DrillDownReport({ 
    queries,
    isDrillDownReportVisible,
    setIsDrillDownReportVisible: setIsDrillDownReportVisible_props,
    selectedSalesPersonDrillDown,
    setSelectedSalesPersonDrillDown: setSelectedSalesPersonDrillDown_props
}) {
    let setIsDrillDownReportVisible = isFunction(setIsDrillDownReportVisible_props)? setIsDrillDownReportVisible_props:() => {};
    let setSelectedSalesPersonDrillDown = isFunction(setSelectedSalesPersonDrillDown_props)? setSelectedSalesPersonDrillDown_props:() => {};

    const {
        getCreditNoteCommissionDrillDownList_requesting, creditNoteCommissionDrillDownList,
        creditNoteCommissionDrillDownListHeader
    } = useCustomSelector("reporting");

    const { 
        getCreditNoteCommissionDrillDownList = () => {} 
    } = useReporting();

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers"); 

    const columns = useDrillDownReportColumns();

    return (
        <DashboardLayout
            headerTitle={selectedSalesPersonDrillDown}

            bodyClassName={"credit-note-commission-drill-down"}
            body={(
                <GeneralTable
                    className={"credit-note-commission-drill-down__table"}
                    columns={columns}
                    data={userPermissions?.Internal_SalesPersonReport_View? creditNoteCommissionDrillDownList: []}
                    getTableData={(currentPage, pageSize, sort, filterOptions) => {
                        getCreditNoteCommissionDrillDownList(currentPage, pageSize, undefined, queries.current);
                    }}

                    isTableDataLoading={getCreditNoteCommissionDrillDownList_requesting}
                    isTableRefreshRequired={isDrillDownReportVisible}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(creditNoteCommissionDrillDownListHeader)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}

            isHeaderCloseIconVisible
            onClose={() => {
                setSelectedSalesPersonDrillDown(undefined);
            }}
            updateParentState_visiblity={setIsDrillDownReportVisible}
        />
    );
}

export default DrillDownReport;